import { CheckoutDirectDebitMethod } from '@checkout';
import { ClientBrandCode, RequestAction, RequestSource } from '@common';
import { BuildConfig, DomainId } from '@config';

export const buildConfig: BuildConfig = {
  applianceRegistrationLimit: 10,
  appVariantConfigPath: 'ie/sidedoor',
  buildFeatures: {},
  checkout: {
    directDebit: {
      method: CheckoutDirectDebitMethod.IBAN,
    },
  },
  defaultDomainId: DomainId.Hotpoint,
  domainIdMapping: {
    [DomainId.Beko]: /beko\.[\w.-]*partners/,
    [DomainId.Beko2YearPartsGuarantee]: /beko2\.[\w.-]*partners/,
    [DomainId.Beko10YearPartsGuarantee]: /beko10(?:pg)*\.[\w.-]*partners/,
    [DomainId.Hotpoint]: /hotp(?:oint)*\.[\w.-]*partners/,
    [DomainId.Indesit]: /indesit\.[\w.-]*partners/,
    [DomainId.Leisure]: /leisure\.[\w.-]*partners/,
    [DomainId.Whirlpool]: /whirl(?:pool)*\.[\w.-]*partners/,
  },
  modelNumberSearchEnabledBrands: [
    ClientBrandCode.Beko,
    ClientBrandCode.Hotpoint,
    ClientBrandCode.Indesit,
    ClientBrandCode.Whirlpool,
  ],
  retailerFieldEnabledBrands: [],
  requestAction: RequestAction.OnlineRegistration,
  whiteLabelClient: RequestSource.DomesticAndGeneralIE,
};
